import { Component, components, Entity, registerComponent } from "aframe";
import { InputActionDetail, InputActionEvent } from "../input/common";



interface CursorControlData
{
	eventSource : Entity;
	sensivity : number;
	enabled : boolean;
	up: string[];
	down: string[];
	left: string[];
	right: string[];
}

interface CursorControlComponent extends Component
{
	data : CursorControlData;
	inputListener : EventListener;
	up : InputActionDetail[];
	down : InputActionDetail[];
	left : InputActionDetail[];
	right : InputActionDetail[];
}

const amountOf = (actions : InputActionDetail[] ) =>
{
	let a = 0.0;
	for(let i of actions)
		if(i.amount > a)
			a = i.amount;
	return a;
}

const handleInput = (event : InputActionEvent, actions : InputActionDetail[] ) =>
{
	const ix = actions.indexOf(event.detail);
	if(event.type == "input-begin")
	{
		if(ix >= 0) return;
		actions.push(event.detail);
		event.preventDefault();
		event.stopPropagation();
	}
	else if(ix >= 0)
	{
		actions.splice(ix, 1);
	} 
}

registerComponent("cursor-control", {
	schema : {
		"eventSource" : { type : "selector" },
		"enabled" : { type : "boolean", default : true },
		"sensivity" : { type : "number", default : 0.1 },
		"up" : { type : "array", default : ["MoveForward"] },
		"down" : { type : "array", default : ["MoveBackward"] },
		"left" : { type : "array", default : ["MoveLeft"] },
		"right" : { type : "array", default : ["MoveRight"] },
	},

	init(this : CursorControlComponent)
	{
		this.up = [];
		this.down = [];
		this.left = [];
		this.right = [];

		this.inputListener = ((event : InputActionEvent) =>
		{
			const action = event.detail.action;

			const someBefore = Boolean( this.up.length || this.down.length || this.left.length || this.right.length );

			if(this.data.up.includes(action))
				handleInput(event, this.up);
			if(this.data.down.includes(action))
				handleInput(event, this.down);
			if(this.data.left.includes(action))
				handleInput(event, this.left);
			if(this.data.right.includes(action))
				handleInput(event, this.right);

			const someAfter = Boolean( this.up.length || this.down.length || this.left.length || this.right.length );

			if(someBefore != someAfter)
				this.el.emit( someAfter ? 'begin-cursor-control' : 'end-cursor-control', this );

		}) as EventListener;
	},

	update(this : CursorControlComponent, oldData : CursorControlData)
	{
		if(oldData.eventSource && oldData.enabled)
		{
			oldData.eventSource.removeEventListener("input-begin", this.inputListener, {capture:true});
			oldData.eventSource.removeEventListener("input-end", this.inputListener, {capture:true});
		}

		const src = this.data.eventSource;
		if(src && this.data.enabled)
		{
			src.addEventListener("input-begin", this.inputListener, {capture:true});
			src.addEventListener("input-end", this.inputListener, {capture:true});
		}
	},

	tick(this : CursorControlComponent, time, timeDelta) {
		if(!this.data.enabled) return;
		const k = timeDelta * this.data.sensivity * 0.001; //Position units
		this.el.object3D.position.x += k * (amountOf( this.right ) - amountOf( this.left ));
		this.el.object3D.position.y += k * (amountOf( this.up ) - amountOf( this.down ));

	},


});
